import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Sharing from '../Common/Sharing'

export default class SharingStoringen extends Component {
  static propTypes = {
    config: PropTypes.object,
  }

  render() {
    const {
      print,
      mail,
      whatsapp
    } = this.props.config;

    return (
      <Sharing
        className="storingen__shares"
        print={print}
        mail={mail}
        whatsapp={whatsapp}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Storingen/Sharing.js